var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
// import { MonetizationStore } from '../../MonetizationStore'
// import { getPriceFormat } from '../../Helpers/helpers'
// import { updateMonetizationStore } from '../../updateStore'
import pubsub from "@viewlift/pubsub";
// import {parseJSON} from "../../helper"
var StripeButtons = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var metadataMap = _a.metadataMap, isValid = _a.isValid, moduleData = _a.moduleData, isDisabled = _a.isDisabled, ctaText = _a.ctaText;
    var _l = __read(useState(null), 2), currentPlan = _l[0], setCurrentPlan = _l[1];
    var _m = __read(useState(null), 2), firstPayment = _m[0], setFirstPayment = _m[1];
    var _o = __read(useState(null), 2), legalVerbiage = _o[0], setLegalVerbiage = _o[1];
    var _p = __read(useState(false), 2), isLoaded = _p[0], setIsLoaded = _p[1];
    var _q = __read(useState(null), 2), alert = _q[0], setAlert = _q[1];
    var _r = __read(useState(false), 2), isProcessing = _r[0], setIsProcessing = _r[1];
    // const updateCardStatus = parseJSON(sessionStorage.getItem('updateCardStatus')); 
    var addText = (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.addCard) || 'Add Card';
    var processingText = (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.processingTxt) || 'Processing';
    var updateCardText = ((_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.app_data) === null || _b === void 0 ? void 0 : _b.appcmsMain) === null || _c === void 0 ? void 0 : _c.genericMessages) === null || _d === void 0 ? void 0 : _d.updateCardText) || "Update Card";
    var getMonetizationStore = function (data) {
        setCurrentPlan(data.currentSelectedPlan);
        setFirstPayment(data.firstPayment);
    };
    var getDiscountedData = function (data) {
        setFirstPayment(data);
    };
    var isLoadedFunc = function (data) {
        if (data)
            setIsLoaded(false);
        else
            setIsLoaded(true);
    };
    useEffect(function () {
        pubsub.subscribe('isLoading', isLoadedFunc);
        pubsub.subscribe('firstPayment', getDiscountedData);
        pubsub.subscribe('monetizationStore', getMonetizationStore);
        // updateMonetizationStore()
    }, []);
    var getIsProcessing = function (data) {
        setIsProcessing(data);
    };
    var disableCtaColor = ((_f = (_e = moduleData === null || moduleData === void 0 ? void 0 : moduleData.layout) === null || _e === void 0 ? void 0 : _e.settings) === null || _f === void 0 ? void 0 : _f.disabledCTAColor) || 'rgba(89, 93, 102, 1)';
    var activeCtaColor = ((_h = (_g = moduleData === null || moduleData === void 0 ? void 0 : moduleData.layout) === null || _g === void 0 ? void 0 : _g.settings) === null || _h === void 0 ? void 0 : _h.activeCTAColor) || '#cf0a2c';
    var inputColor = ((_k = (_j = moduleData === null || moduleData === void 0 ? void 0 : moduleData.layout) === null || _j === void 0 ? void 0 : _j.settings) === null || _k === void 0 ? void 0 : _k.inputColor) || '#fff';
    useEffect(function () {
        pubsub.subscribe('processing', getIsProcessing);
        // if (firstPayment && currentPlan && isLoaded) {
        //   let date = new Date(firstPayment?.planData?.nextBillingDate);
        //   let verbiage = metadataMap.billingAcceptVerbiage
        //   date = date.toLocaleString('en-US')
        //   let expiration = date || ''
        //   let planDetails = currentPlan?.planDetails?.length ? currentPlan.planDetails[0] : null
        //   if (planDetails) {
        //     let priceFormat = getPriceFormat(planDetails, currentPlan)
        //     verbiage = verbiage && verbiage.replace(/\[deadline\]/g, expiration)
        //     verbiage = verbiage && verbiage.replace(/\[price\]/g, priceFormat)
        //     setLegalVerbiage(verbiage)
        //   }
        // }
    }, [currentPlan]);
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { "aria-labelledby": ctaText || 'Subscribe & Pay', className: "".concat(!isValid || isDisabled ? 'button continue-button disabled' : 'button continue-button site-cta-color '), style: !isValid || isDisabled ? { background: disableCtaColor, color: inputColor } : { background: activeCtaColor }, disabled: isValid && !isDisabled ? false : true, type: "submit", 
            // value={isProcessing ? processingText : addText} 
            value: ctaText || 'Subscribe & Pay', "data-test": "subscribe-submit-btn" })));
};
export default StripeButtons;
